import { getEmbarcacaoSistemasDp } from "./embarcacoes.gateway";
import { isEmbarcacaoSistemasDpEmpty } from "./embarcacoes.types";
import type { EmbarcacaoSistemasDp, EmbarcacaoSistemasDpState } from "./embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

export const SISTEMAS_DP_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const SISTEMAS_DP_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const SISTEMAS_DP_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const SISTEMAS_DP_ERROR_MESSAGE =
  "Não foi possível carregar os Sistemas de DP da embarcação.";

const SISTEMAS_DP_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoSistemasDp> = {
  load: getEmbarcacaoSistemasDp,
  isEmpty: isEmbarcacaoSistemasDpEmpty,
  messages: {
    sessionExpired: SISTEMAS_DP_SESSION_EXPIRED_MESSAGE,
    forbidden: SISTEMAS_DP_FORBIDDEN_MESSAGE,
    notFound: SISTEMAS_DP_NOT_FOUND_MESSAGE,
    error: SISTEMAS_DP_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoSistemasDpResult extends EmbarcacaoSistemasDpState {
  reload: () => void;
}

/**
 * Consulta os Sistemas de DP da embarcação pedida (AC4). Somente leitura:
 * nenhuma escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoSistemasDp(id: string): UseEmbarcacaoSistemasDpResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, SISTEMAS_DP_QUERY);

  return { ...state, sistemasDp: data };
}
